import { render } from "./pl5-ge.vue?vue&type=template&id=72702ef2&scoped=true"
import script from "./pl5-ge.vue?vue&type=script&lang=js"
export * from "./pl5-ge.vue?vue&type=script&lang=js"

import "./pl5-ge.vue?vue&type=style&index=0&id=72702ef2&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72702ef2"]])

export default __exports__